export default __webpack_public_path__ + "static/media/11.df5d80ac.png";